export default "__VITE_ASSET__DYXe1Tcs__"